const FILTER_STORAGE_KEY = 'atek-eqms-column-filters';

export function loadEqmsColumnFilters() {
  try {
    return JSON.parse(localStorage.getItem(FILTER_STORAGE_KEY) || '{}') as Record<string, string>;
  } catch {
    return {};
  }
}

export function persistEqmsColumnFilters(filters: Record<string, string>) {
  localStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify(filters));
}
